module.exports = __webpack_public_path__ + "r-v3/img/ico_radio_checked.ad0edb89.svg";